import React from 'react'
import {Col, Row, Panel} from 'react-bootstrap'
import './style.css';

const OutletSearch = (props) => {
  const doSearch = (e) => {
    if (e.key === 'Enter') {
      props.onSearch();
    }
  };

  return (
    <Row>
      <Col md={12}>
        <Panel className="mg-tb-20">
          <div className="fluid">
            <input onChange={props.onChange}
                   onKeyPress={doSearch}
                   placeholder="Search by outlet id, customer number, outlet name, Eircode..."
                   className="form-control"
                   value={props.searchValue}/>
          </div>
          <div className="fluid text-right search-button">
            <button className="btn red-ghost-btn mg-10" onClick={props.onSearch}>Search</button>
            <button className="btn red-ghost-btn mg-10" onClick={props.onClear}>Clear Search</button>
          </div>
        </Panel>
      </Col>
    </Row>
  );
};

export default OutletSearch;


// WEBPACK FOOTER //
// ./src/components/admin/outlet-list/outlet-search.jsx